const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 7.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z"/><path fill-rule="evenodd" d="M2.75 6.5A3.75 3.75 0 0 1 6.5 2.75h11a3.75 3.75 0 0 1 3.75 3.75v11a3.75 3.75 0 0 1-3.75 3.75h-11a3.75 3.75 0 0 1-3.75-3.75zM6.5 4.25A2.25 2.25 0 0 0 4.25 6.5v11a2.25 2.25 0 0 0 2.25 2.25h11a2.25 2.25 0 0 0 2.25-2.25v-11a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/></svg>';
export {
  a as w
};
